import { Storage } from '@ionic/storage';
import { ReactNode, createContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { GetLocationNumberBySap } from "../services/Tableau";
import { GetCurrent } from "../services/Users";

interface UserContextProps {
  user: any;
  setUser: (user: any | (() => any)) => void;
  location_number: number;
  setLocationNumber: (location_number: number | (() => number)) => void;
  category: string;
  setCategory: (category: string | (() => string)) => void;
}

interface UserProviderProps {
  children: ReactNode
}

const IonicStorage = new Storage({
  name: 'mock-server'
})

const PUBLIC_URLS = [
  '/auth/callback'
]



const UserContext = createContext<UserContextProps | null>(null)

const UserProvider = ({ children }: UserProviderProps) => {
  const [user, setUser] = useState<any>()
  const [location_number, setLocationNumber] = useState<number>(1)
  const [category, setCategory] = useState<string>('LCBO')
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    (async () => {
      const category = searchParams.get('category')
      if (category) {
        setCategory(() => category)
      }
      const token = searchParams.get('token')
      if (token) {
        const storage = await IonicStorage.create()
        await storage.set(`token`, token)
      }
      const sap_id = searchParams.get('sap_id')
      if (sap_id) {
        const { data } = await GetLocationNumberBySap(category as string, parseInt(sap_id))
        const { location_number } = data
        setLocationNumber(() => location_number)
      } else {
        setLocationNumber(() => 1)
      }
      try {
        const user = await GetCurrent()
        setUser(() => user)
      } catch (e: any) {
        if (PUBLIC_URLS.indexOf(location.pathname) === -1) {
          navigate('/login')
        }
      }
    })()
  }, [navigate, location, searchParams])

  return (
    <UserContext.Provider value={{
      user, setUser,
      location_number, setLocationNumber,
      category, setCategory
    }}>
      {children}
    </UserContext.Provider>
  )
};


export {
  UserContext,
  UserProvider
};

export type {
  UserContextProps
};
